export default "<img\n  class=\"logo\"\n  [src]=\"logoPath\"\n  [alt]=\"'Logo' | translatorPipe\"\n/>\n";